import BaseClass from "../util/BaseClass";
import Context from "./Context";
import Topic from "./Topic";
import Views from "./Views";
import * as idleTimeOut from "../../src/util/idleTimeOut";
import * as localStore from "../../src/util/localStore";

export default class Starter extends BaseClass {

  considerNativeApp;

  _checkBrowser() {
    const promise = new Promise((resolve,reject) => {
      const context = Context.getInstance();

      const result = context.lib.esri.WebGLRequirements.check();
      //console.log("WebGLRequirements.check",result)
      if (result) {
        context.supports3D = false;
        if (result.name === "webgl:major-performance-caveat-detected") {
          console.warn("Your browser isn't using hardware acceleration for rendering");
        } else {
          console.warn("Your browser doesn't seem to support WebGL");
        }
      }
      resolve();
    });
    return promise;
  }

  _checkLicense(context,portal) {

    // if (!portal.isPortal) {
    //   console.log("********** BY-PASSING INDOORS LICENSE CHECK **********");
    //   return Promise.resolve();
    // }

    const promise = new Promise((resolve,reject) => {
      const i18n = Context.instance.i18n;
      const msg = "__noIndoorsSubscription__";
      let uiMsg = i18n.messages.noIndoorsSubscription;
      let id = encodeURIComponent(portal.id);
      if (!portal.id) id = encodeURIComponent("0123456789ABCDEF");
      let url = portal.restUrl;
      url += "/portals/"+ id + "/subscriptionInfo";
      const query = {f: "json"};
      const options = {query: query, method: "get", responseType: "json"};
      Context.instance.lib.esri.esriRequest(url,options).then(result => {
        let ok = false;
        if (result && result.data && result.data.orgCapabilities && result.data.orgCapabilities.length > 0) {
          result.data.orgCapabilities.some(capability => {
            if (capability && capability.id === "indoors") {
              ok = true;
              let status = capability.status;
              //let endDate = capability.endDate;
              if (typeof status === "string") {
                if (status.toLowerCase() === "expired") {
                  ok = false;
                  uiMsg = i18n.messages.noIndoorsSubscription_Expired;
                } else if (status.toLowerCase() === "cancelled") {
                  ok = false;
                  uiMsg = i18n.messages.noIndoorsSubscription_Cancelled;
                }
              }
              return true;
            }
            return false;
          });
        }
        if (ok) {
          //console.log(". . . . . . .");
          resolve(ok);
        } else {
          Context.instance.noIndoorsSubscriptionMsg = uiMsg;
          reject(msg);
        }
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

  _checkSignIn() {
    const promise = new Promise((resolve,reject) => {
      const context = Context.getInstance();
      //const portalUrl = context.config.portalUrl;
      const sharingUrl = context.getSharingUrl();
      const esriId = context.lib.esri.esriId;

      const openApp = (authMode) => {
        if (!authMode) {
          const urlUtils = context.lib.esri.urlUtils;
          const urlObject = urlUtils.urlToObject(window.location.href);
          if (urlObject && urlObject.query) {
            // force a sign-in if starting in configurator mode
            if (urlObject.query.configure === "true" ||
                urlObject.query.edit === "true") {
              authMode = "immediate"
            }
          }
          if (context.appMode.requiresImmediateAuthentication()) {
            authMode = "immediate";
          }
        }
        this._openApp(authMode).then(() => {
          resolve();
        }).catch(ex => {
          reject(ex);
        });
      };

      const oauthInfo = new context.lib.esri.OAuthInfo({
        appId: context.config.oauthAppId,
        portalUrl: context.config.portalUrl,
        // Uncomment the next line and update if using your own portal
        // portalUrl: "https://<host>:<port>/arcgis"
        // Uncomment the next line to prevent the user's signed in state from being shared
        //   with other apps on the same domain with the same authNamespace value.
        // authNamespace: "portal_oauth_inline",
        popup: false
      });
      esriId.registerOAuthInfos([oauthInfo]);

      esriId.checkSignInStatus(sharingUrl).then(cred => {
        // if (context.config.allowAnonymousAccess) {
        //   openApp();
        // } else {
        //   openApp("immediate");
        // }
        openApp("immediate");
      }).catch((ex) =>{
        if (context.config.allowAnonymousAccess) {
          //oauthInfo.popup = true;
          /*
          if (oauthInfo.popup) {
            esriId.on("credential-create",result => {
              if (result && result.credential) {
                const sameUrl = (result.credential.server === portalUrl);
                const sameOAuthInfo = (result.credential._oAuthCred &&
                  result.credential._oAuthCred.oAuthInfo === oauthInfo);
                if (sameUrl && sameOAuthInfo) {
                  this._reloadPortal();
                }
              }
            });
          }
          */
          openApp();
        } else {
          esriId.getCredential(sharingUrl);
          reject();
        }
      });

    });
    return promise;
  }

  _checkUser(context,portal) {
    if (context.appMode.isSpacePlanner()) {
      const user = context.user;
      const isPortal = Context.instance.getPortal().isPortal;
      let ok = false;

      if(isPortal){
        ok = (user && (user.isAdmin() || user.isPublisher() || user.isFullDataEdit()|| user.isDataEdit()));
      }else{
        ok = (user && (user.isAdmin() || user.isPublisher()));
      }

      if (!ok) {
        let errorMessage;
        if(isPortal) errorMessage= context.i18n.spaceplanner.application.higherPrivilegesRequiredEnterprise;
        else errorMessage= context.i18n.spaceplanner.application.higherPrivilegesRequiredOnline;
        const error = new Error(errorMessage);
        error.xtnCode = "__invalidUser__";
        return Promise.reject(error)
      }
    }
    return Promise.resolve();
  }

  _fix() {

    // TODO this should be url based, only reset maxAllowableOffset for AIIM layers
    const interceptor = {
      before: function(params) {
        //console.log("interceptor.before",params);

        // JSAPI 4.11 -> can't set esriDOTFeatureSets in RouteParameters
        if (params && params.requestOptions && params.requestOptions.query &&
            params.requestOptions.query.directionsOutputType) {
          if (params.requestOptions.query.directionsOutputType === "esriDOTComplete") {
            params.requestOptions.query.directionsOutputType = "esriDOTFeatureSets";
          }
        }

        let wasUpdated = false;
        if (!wasUpdated && params && params.requestOptions && params.requestOptions.query &&
            params.requestOptions.query.maxAllowableOffset) {
          //console.log("****** interceptor.before.query.maxAllowableOffset",params.requestOptions.query);
          //console.warn("esriRequest:resetting maxAllowableOffset",params);
          params.requestOptions.query.maxAllowableOffset = 0;
          wasUpdated = true;
        }
        if (!wasUpdated && params && typeof params.url === "string" &&
            params.url.toLowerCase().indexOf("maxAllowableOffset") !== -1) {
          //console.log("*** interceptor.before.url.maxAllowableOffset",params.url,params.requestOptions.query);
          if (params.requestOptions && params.requestOptions.query) {
            console.warn("esriRequest:resetting maxAllowableOffset",params);
            params.requestOptions.query.maxAllowableOffset = 0;
            wasUpdated = true;
          }
        }

        if (params && typeof params.url === "string" &&
            params.url.indexOf("/applyEdits") !== -1) {
          //console.log("*** interceptor.before.url.applyEdits",params.url,params);
          if (params.requestOptions) {
            params.requestOptions.timeout = (60000 * 30);
          }
        }
      }
    };
    const requestConfig = Context.getInstance().lib.esri.esriConfig.request;
    if (Array.isArray(requestConfig.interceptors)) {
      requestConfig.interceptors.push(interceptor);
    } else {
      requestConfig.interceptors = [interceptor];
    }

  }

  displayToast(){
    let key = null;
    if(Context.instance.user.isAnonymous()) {
      const isSpacePlanner = Context.instance.appMode.isSpacePlanner();
      if(!isSpacePlanner) key = localStore.keys.viewerSignOut;
      const value = localStore.getItem(key, "toastmsg");
      if(value) {
        const applicationReset = Context.instance.config.applicationReset;
        const timeoutInMilliseconds = applicationReset.timeoutMillis/1000;
        let msg = "You were signed out of the app for being inactive for {Idle Time} seconds.";
        msg = msg.replace("{Idle Time}", timeoutInMilliseconds);
        localStore.removeItem(key,"toastmsg");
        Topic.publish(Topic.ShowToast,{message: msg});
      }
    }
  }

  _listen() {

    Topic.subscribe(Topic.AppStarted,(params) => {
      //console.log("Starter::Topic.AppStarted.................");
      //Topic.publish(Topic.ShowToast,{message:"This is a message"});
      const configuration = Context.getInstance().configuration
      const configurables = configuration.extractConfigurables()
      if (configurables.officeHoteling && configurables.officeHoteling.enabled) {
        Context.getInstance()._loadHotelingUnits()
        Context.getInstance()._loadAreas()
      }
    });

    Topic.subscribe(Topic.SignInClicked,() => {
      const lib = Context.getInstance().lib;
      const sharingUrl = Context.getInstance().getSharingUrl();
      const options = {
        oAuthPopupConfirmation: false
      };
      lib.esri.esriId.getCredential(sharingUrl,options).then(cred => {
      }).catch((ex) =>{
        // TODO need to inform user?
        console.log("Signin failed");
        console.error(ex);
      });
    });

    Topic.subscribe(Topic.SignOutClicked,() => {
      const lib = Context.getInstance().lib;
      const esriId = lib.esri.esriId;
      const useRevokeOnly = false;
      if (useRevokeOnly) {
        esriId.destroyCredentials();
        window.location.reload();
      } else {
        esriId.destroyCredentials();
        const redirectUri = window.location.href;
        const clientId = Context.getInstance().config.oauthAppId;
        const sharingUrl = Context.getInstance().getSharingUrl();
        let url = sharingUrl + "/rest/oauth2/signout"
        url += "?client_id=" + encodeURIComponent(clientId);
        url += "&redirect_uri=" + encodeURIComponent(redirectUri);
        //console.log("signout url",url);
        window.location.href = url;
      }
    });

  }

  getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  getCookies = () => {
    return document.cookie.split(';').reduce((cookies, cookie) => {
      const [name, val] = cookie.split('=').map(c => c.trim());
      if (!name.includes('msal')) {
        cookies[name] = val;
      }
      return cookies;
      }, {});
  }

  loadUrlParams = () => {
    const appid = this.getCookie("appid")
    console.log(appid)
    if (appid) {
      const split = window.location.href.split('#')
      const token = split[split.length - 1]
      console.log(token)
      if ((token.includes("id_token") || token.includes("access_token")) && split.length === 2 && !window.location.href.includes("appid")) {
        const params = this.getCookies()
        console.log(params)
        if (Object.keys(params).length > 0) {
          let url = split[0] + "?"
          Object.keys(params).forEach(key => {
            url += key + "=" + params[key] + "&"
          })
          url = url.replace(/.$/, '#')
          url += token
          console.log(url)
          window.location.href = url
        }
      }
    }
  }

  _openApp(authMode?) {
    const context = Context.getInstance();
    const lib = context.lib;
    const portalUrl = context.config.portalUrl;
    lib.esri.esriConfig.portalUrl = portalUrl;
    const portal = new lib.esri.Portal();
    if (authMode) portal.authMode = "immediate";
    let loadData = true;
    return portal.load().then(result => {
      console.log("loadPortal:result", result);
      context.portal = portal;
      context.user.setPortal(portal);
    }).then(result => {
      return this._checkLicense(context,portal);
    }).then(result => {
      return this._checkUser(context,portal);
    }).then(result => {
      return context._load();
    }).then(result => {
      if (this.considerNativeApp) {
        if (context.config.nativeApp && context.config.nativeApp.showIOS) {
          loadData = false;
        }
      }
      if (loadData) {
        context.views = new Views();
        return context.views.load();
      }
    }).then(result => {
      if (loadData) return context.aiim.load();
    }).then(result => {
      if (loadData) {
        idleTimeOut.start()
        Topic.publish(Topic.AppStarted,{});
      }
    });
  }

  reloadViews(params) {
    const context = Context.getInstance();
    Context.getInstance().views.destroy();
    Context.getInstance().aiim.reset();
    Context.getInstance().session.viewsReloading();
    context.views = new Views({
      startIn3D: params && params.startIn3D
    });
    return context.views.load().then(() => {
      return context.aiim.load();
    }).then(() => {
      Topic.publish(Topic.ViewsReloaded,{});
    });
  }

  reloadPortal=()=> {
    const context = Context.getInstance();
    const portal = new context.lib.esri.Portal();
    console.log("Reload portal", portal);
    portal.authMode = "immediate";

    portal.load().then(function(result){
      console.log("loadPortal.result:",result);
      context.portal = portal;
      context.user.setPortal(portal);
      Topic.publish(Topic.SignedIn,{});
    }).catch(function(ex2){
      // TODO need to inform user?
      console.log("Error loading portal:");
      console.error(ex2);
    });
  }

  _showMessage(msg) {
    try {
      const el = document.createElement("div");
      el.style.padding = "20px";
      el.innerHTML = Context.sanitizeHtml(msg);
      document.body.appendChild(el);
    } catch (ex) {
      console.error("Startup: error showing message:",msg,ex);
    }
  }

  startupApp() {
    const promise = new Promise((resolve,reject) => {
      this.loadUrlParams()
      const context = Context.getInstance();

      /*
      context._init().then(() => {
        this._listen();
        this._fix();
      }).then(() => {
        return this._checkBrowser();
       */

      this._listen();
      this._fix();
      this._checkBrowser().then(() => {
        return this._checkSignIn();
      }).then(() => {
        context.uiMode.hideSkeleton();
        resolve();
      }).catch(ex => {
        if (context.uiMode) {
          context.uiMode.hideSkeleton();
        } else {
          document.body.classList.remove("i-skeleton-on");
          document.getElementById("skeleton").style.display = "none";
        }
        reject(ex);
      });
    });
    return promise;
  }

}
